export class DiscordMountContentFrameListener {
    listenForMessagesFromContentFrame() {
        window.addEventListener('message', (messageData)=>void this.handleMessageReceivedFromContentFrame(messageData));
    }
    async handleMessageReceivedFromContentFrame({ data: messageData }) {
        if (typeof messageData !== 'object') return;
        if (Array.isArray(messageData)) return;
        if (messageData === null) return;
        await this.discordMountController.handleMessageReceivedFromContentFrame(messageData);
    }
    constructor(discordMountController){
        this.discordMountController = discordMountController;
        this.listenForMessagesFromContentFrame();
    }
}
